function buildWbsTree(activities = []) {
  const roots = [];
  const nodeMap = new Map();

  activities.forEach((act) => {
    if (!Array.isArray(act.wbs_path) || act.wbs_path.length === 0) return;

    let current = roots;

    act.wbs_path.forEach((path, idx) => {
      let node = nodeMap.get(path);

      if (!node) {
        const name = path.split(".").at(-1);

        node = {
          key: path,
          name,                // ✅ 사람이 읽는 이름
          children: [],
          activities: [],
        };

        nodeMap.set(path, node);
        current.push(node);
      }

      // leaf에만 activity 붙임
      if (idx === act.wbs_path.length - 1) {
        node.activities.push(act);
      }

      current = node.children;
    });
  });

  return roots;
}

export { buildWbsTree };
